import React from 'react'
import { inject, observer } from 'mobx-react'
import Modal from '../../../generic/Modal'
import Highlight from 'react-highlight'

const NFEModal = inject('nfeStore')(observer(props => {
  const { nfeStore } = props
  const { xmlModal, files } = nfeStore.state
  const modalIsDownloading = files.length !== 0 && xmlModal.xml.get('Key') ? (
    files.find(data => data.Key === xmlModal.xml.get('Key'))
  ) : (
    {isDownloading: false}
  )
  const modalOptions = [
    {
      text: 'Download',
      type: 'button',
      onClick: () => nfeStore.downloadNfe(
        xmlModal.xml.get('Key'),
        xmlModal.xml.get('Key').split('_')[0].split('/').reverse()[0]
      ),
      isLoading: modalIsDownloading.isDownloading
    }
  ]
  if (!xmlModal.xml.has('body')) {
    return null
  }
  return (
    <Modal 
      isActive={xmlModal.isActive} 
      onClose={() => nfeStore.closeModal()} 
      title='XML' 
      options={modalOptions}
    >
      <Highlight className='html'>{xmlModal.xml.get('body')}</Highlight>
    </Modal>
  )
}))

export default NFEModal



// WEBPACK FOOTER //
// ./src/components/dashboard/products/4nfe/NFEModal.js